import { useState, useCallback } from 'react';

const useToast = () => {
  const [toast, setToast] = useState({
    show: false,
    type: 'info',
    message: '',
    duration: 3000,
  });

  const showToast = useCallback((message, type = 'info', duration = 3000) => {
    setToast({
      show: true,
      type,
      message,
      duration,
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast((prev) => ({ ...prev, show: false }));
  }, []);

  const showSuccess = useCallback(
    (message, duration = 3000) => {
      showToast(message, 'success', duration);
    },
    [showToast]
  );

  const showError = useCallback(
    (message, duration = 5000) => {
      showToast(message, 'error', duration);
    },
    [showToast]
  );

  const showWarning = useCallback(
    (message, duration = 4000) => {
      showToast(message, 'warning', duration);
    },
    [showToast]
  );

  const showInfo = useCallback(
    (message, duration = 3000) => {
      showToast(message, 'info', duration);
    },
    [showToast]
  );

  const showLoading = useCallback(
    (message) => {
      showToast(message, 'loading', 0); // 0 duration means it won't auto-hide
    },
    [showToast]
  );

  return {
    toast,
    showToast,
    hideToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showLoading,
  };
};

export default useToast;
